import { Routes } from '@angular/router';
import { CreatePageComponent } from './create-page/create-page.component';
import { AuthGuard } from '../../../guards/auth.guard';
import { IsCompletedUserDataGuard } from '../../../guards/is-completed-user-data.guard';
import { opinionOfConformityRoutes } from './opinion-of-conformity/opinion-of-conformity.routes';
import {
  irspaApplicationForTheProjectRoutes
} from './irspa-application-for-the-project/irspa-application-for-the-project.routes';
import { irspaAmendTheActRoutes } from './irspa-amend-the-act/irspa-amend-the-act.routes';
import {
  irspaWarningOnTheConsultedDraftRoutes
} from './irspa-warning-on-the-consulted-draft/irspa-warning-on-the-consulted-draft.routes';
import {
  irspaPreparationOfTheActRoutes
} from './irspa-preparation-of-the-act/irspa-preparation-of-the-act.routes';
import {
  certAboutConformityOfUseWithMpzpRoutes
} from './cert-about-conformity-of-use-with-mpzp/cert-about-conformity-of-use-with-mpzp.routes';
import {
  wExtractAndDraftFromStudyRoutes
} from './w-extract-and-draft-from-study/w-extract-and-draft-from-study.routes';
import { wExtractAndDraftMpzpRoutes } from './w-extract-and-draft-mpzp/w-extract-and-draft-mpzp.routes';
import {
  wCertificateFromMunicipalRegisterRoutes
} from './w-certificate-from-municipal-register/w-certificate-from-municipal-register.routes';
import {
  wLocationPropertyInRevitalizationAreaRoutes
} from './w-location-property-in-revitalization-area/w-location-property-in-revitalization-area.routes';
import { responseToCallRoutes } from './response-to-call/response-to-call.routes';
import { generalLetterRoutes } from './general-letter/general-letter.routes';
import { documentsInformationRoutes } from './documents-information/documents-information.routes';
import {
  certAboutConformityOfStudyRoutes
} from './cert-about-conformity-of-study/cert-about-conformity-of-study.routes';
import { leaseOfABurialPlaceRoutes } from './lease-of-a-burial-place/lease-of-a-burial-place.routes';
import {
  applicationForACemeterySpaceRoutes
} from './application-for-a-cemetery-space/application-for-a-cemetery-space.routes';
import {
  registrationForTheSewageTreatmentRoutes
} from './registration-for-the-sewage-treatment-plant-register/registration-for-the-sewage-treatment-plant-register.routes';
import {
  wDeterminingPlanningFeeBeforeSaleOfPropertyRoutes
} from './w-determining-planning-fee-before-sale-of-property/w-determining-planning-fee-before-sale-of-property.routes';
import {
  submittingAnInvestorLetterOfIntentRoutes
} from './submitting-an-investor-letter-of-intent/submitting-an-investor-letter-of-intent.routes';
import { generalApplicationRoutes } from './general-application/general-application.routes';
import { removalOfTreesOrShrubsRoutes } from './removal-of-trees-or-shrubs/removal-of-trees-or-shrubs.routes';
import { municipalWasteDisposalRoutes } from './municipal-waste-disposal/municipal-waste-disposal.routes';
import {
  coordinatingTrafficOrganizationProjectsRoutes
} from './coordinating-traffic-organization-projects/coordinating-traffic-organization-projects.routes';
import {
  decisionOnDevelopmentConditionsRoutes
} from './decision-on-development-conditions/decision-on-development-conditions.routes';
import {
  opinionOfConformityOfPropertyDivisionMpzpRoutes
} from './opinion-of-conformity-of-property-division-mpzp/opinion-of-conformity-of-property-division-mpzp.routes';
import {
  decisionOnDeterminingTheLocationOfAPublicPurposeInvestmentRoutes
} from './decision-on-determining-the-location-of-a-public-purpose-investment/decision-on-determining-the-location-of-a-public-purpose-investment.routes';

export const applicationCreatePageRoutes: Routes = [
  {
    component: CreatePageComponent,
    path: 'e-uslugi/odpowiedz-na-wezwanie/skladanie-wniosku',
    children: responseToCallRoutes,
    data: {
      contentUrl: 'odpowiedz-na-wezwanie'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/uzupelnienie-dokumentow/skladanie-wniosku',
    children: documentsInformationRoutes,
    data: {
      contentUrl: 'uzupelnienie-dokumentow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/pismo-ogolne/skladanie-wniosku',
    children: generalLetterRoutes,
    data: {
      contentUrl: 'pismo-ogolne'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/ustalenie-numeru-porzadkowego/skladanie-wniosku',
    children: wLocationPropertyInRevitalizationAreaRoutes,
    data: {
      contentUrl: 'ustalenie-numeru-porzadkowego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zaswiadczenie-z-gminnej-ewidencji-zabytkow/skladanie-wniosku',
    data: {
      contentUrl: 'zaswiadczenie-z-gminnej-ewidencji-zabytkow'
    },
    children: wCertificateFromMunicipalRegisterRoutes,
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wypis-i-wyrys-z-mpzp/skladanie-wniosku',
    data: {
      contentUrl: 'wypis-i-wyrys-z-mpzp'
    },
    children: wExtractAndDraftMpzpRoutes,
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wypis-i-wyrys-ze-studium/skladanie-wniosku',
    data: {
      contentUrl: 'wypis-i-wyrys-ze-studium'
    },
    children: wExtractAndDraftFromStudyRoutes,
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zaswiadczenie-z-mpzp/skladanie-wniosku',
    children: certAboutConformityOfUseWithMpzpRoutes,
    data: {
      contentUrl: 'zaswiadczenie-z-mpzp'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zaswiadczenie-ze-studium/skladanie-wniosku',
    children: certAboutConformityOfStudyRoutes,
    data: {
      contentUrl: 'zaswiadczenie-ze-studium'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wniosek-do-projektu-aktu-planowania-przestrzennego/skladanie-wniosku',
    data: {
      contentUrl: 'wniosek-do-projektu-aktu-planowania-przestrzennego'
    },
    children: irspaApplicationForTheProjectRoutes,
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/opinia-o-zgodnosci-realizacji-obiektow-z-uchwala-krajobrazowa/skladanie-wniosku',
    children: opinionOfConformityRoutes,
    data: {
      contentUrl: 'opinia-o-zgodnosci-realizacji-obiektow-z-uchwala-krajobrazowa'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/uwaga-do-konsultowanego-projaktu-aktu-planowania-przestrzennego/skladanie-wniosku',
    children: irspaWarningOnTheConsultedDraftRoutes,
    data: {
      contentUrl: 'uwaga-do-konsultowanego-projaktu-aktu-planowania-przestrzennego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wniosek-o-zmiane-aktu-planowania-przestrzennego/skladanie-wniosku',
    children: irspaAmendTheActRoutes,
    data: {
      contentUrl: 'wniosek-o-zmiane-aktu-planowania-przestrzennego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wniosek-o-sporządzenie-aktu-planowania-przestrzennego/skladanie-wniosku',
    children: irspaPreparationOfTheActRoutes,
    data: {
      contentUrl: 'wniosek-o-sporządzenie-aktu-planowania-przestrzennego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wniosek-o-dzierzawe-miejsca-grzebalnego/skladanie-wniosku',
    children: leaseOfABurialPlaceRoutes,
    data: {
      contentUrl: 'wniosek-o-dzierzawe-miejsca-grzebalnego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wniosek-o-miejsce-na-cmentarzu/skladanie-wniosku',
    children: applicationForACemeterySpaceRoutes,
    data: {
      contentUrl: 'wniosek-o-miejsce-na-cmentarzu'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zgloszenie-do-ewidencji-przydomowych-oczyszczalni-sciekow/skladanie-wniosku',
    children: registrationForTheSewageTreatmentRoutes,
    data: {
      contentUrl: 'zgloszenie-do-ewidencji-przydomowych-oczyszczalni-sciekow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/ustalenie-oplaty-planistycznej-przed-zbyciem-nieruchomosci/skladanie-wniosku',
    children: wDeterminingPlanningFeeBeforeSaleOfPropertyRoutes,
    data: {
      contentUrl: 'ustalenie-oplaty-planistycznej-przed-zbyciem-nieruchomosci'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zlozenie-listu-intencyjnego-inwestora/skladanie-wniosku',
    children: submittingAnInvestorLetterOfIntentRoutes,
    data: {
      contentUrl: 'zlozenie-listu-intencyjnego-inwestora'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wniosek-ogolny/skladanie-wniosku',
    children: generalApplicationRoutes,
    data: {
      contentUrl: 'wniosek-ogolny'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wniosek-o-wydanie-zezwolenia-na-usuniecie-drzew-lub-krzewow/skladanie-wniosku',
    children: removalOfTreesOrShrubsRoutes,
    data: {
      contentUrl: 'wniosek-o-wydanie-zezwolenia-na-usuniecie-drzew-lub-krzewow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/deklaracja-o-wysokosci-oplaty-za-gospodarowanie-odpadami-komunalnymi/skladanie-wniosku',
    children: municipalWasteDisposalRoutes,
    data: {
      contentUrl: 'deklaracja-o-wysokosci-oplaty-za-gospodarowanie-odpadami-komunalnymi'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/opiniowanie-i-uzgadnianie-projektow-stalej-lub-czasowej-organizacji-ruchu/skladanie-wniosku',
    children: coordinatingTrafficOrganizationProjectsRoutes,
    data: {
      contentUrl: 'opiniowanie-i-uzgadnianie-projektow-stalej-lub-czasowej-organizacji-ruchu'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/decyzja-o-warunkach-zabudowy/skladanie-wniosku',
    children: decisionOnDevelopmentConditionsRoutes,
    data: {
      contentUrl: 'decyzja-o-warunkach-zabudowy'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wniosek-o-opinie-zgodnosci-podzialu-nieruchomosci-z-mpzp/skladanie-wniosku',
    children: opinionOfConformityOfPropertyDivisionMpzpRoutes,
    data: {
      contentUrl: 'wniosek-o-opinie-zgodnosci-podzialu-nieruchomosci-z-mpzp'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/decyzja-o-ustalenie-lokalizacji-inwestycji-celu-publicznego/skladanie-wniosku',
    children: decisionOnDeterminingTheLocationOfAPublicPurposeInvestmentRoutes,
    data: {
      contentUrl: 'decyzja-o-ustalenie-lokalizacji-inwestycji-celu-publicznego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  }
];
